import React from 'react'

import { IntegrationStatusLabel } from '../IntegrationStatusLabel'

/**
 *
 * @param {object} props
 * @param {string} props.title
 * @param {boolean=} props.active
 * @param {boolean=} props.isAutomaticActive
 * @param {boolean=} props.shouldHideActiveLabel
 */
export function IntegrationAccordionTitleContent({
  title,
  active,
  isAutomaticActive,
  shouldHideActiveLabel,
}) {
  if (shouldHideActiveLabel) {
    return (
      <React.Fragment>
        <i className="fas fa-caret-down icon" />
        {title}
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <i className="fas fa-caret-down icon" />
      {title}

      <span className="ml-4">
        <IntegrationStatusLabel active={active} isAutomaticActive={isAutomaticActive} />
      </span>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IntegrationAccordionTitleContent/index.js